import { Component, Input } from '@angular/core';
import { UserAccountType } from '../../../entity/UserAccountType';
import { FavoriteManagerComponent } from '../favorite-manager/favorite-manager.component';

import { UserAccount } from '../../../entity/UserAccount';
import {
  Favorite,
  ItemCastCharacterRelation,
  ItemPersonRelation,
  ItemRelation,
  MainItem,
  MainItemBasic, MainType
} from '@irohalab/mira-sdk-angular';
import { CharacterListComponent } from '../character-list/character-list.component';
import { CharacterItemCastListComponent } from '../character-item-cast-list/character-item-cast-list.component';
import { CastCharacterItemListComponent } from '../cast-character-item-list/cast-character-item-list.component';

@Component({
    selector: 'app-overview',
    imports: [
    FavoriteManagerComponent,
    CharacterListComponent,
    CharacterItemCastListComponent,
    CastCharacterItemListComponent
],
    templateUrl: './overview.component.html',
    styleUrl: './overview.component.less'
})
export class OverviewComponent {
  protected readonly eUserAccountType = UserAccountType;

  @Input()
  user!: UserAccount;

  @Input()
  mainItem!: MainItem;

  @Input()
  favorite!: Favorite;

  @Input()
  itemRelations!: ItemRelation[];

  @Input()
  itemPersonRelations!: ItemPersonRelation[];

  @Input()
  itemCastCharacterRelations!: ItemCastCharacterRelation[];

  @Input()
  relatedMainItems!: MainItemBasic[];
  protected readonly MainType = MainType;
}
